/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { documentDraftsControllerCreate } from "./documentDraftsControllerCreate";
import { documentDraftsControllerDownload } from "./documentDraftsControllerDownload";
import { documentDraftsControllerHistory } from "./documentDraftsControllerHistory";
import { documentDraftsControllerList } from "./documentDraftsControllerList";
import { documentDraftsControllerMessage } from "./documentDraftsControllerMessage";
import { documentDraftsControllerVersion } from "./documentDraftsControllerVersion";

export function documentDraftsService() {
  return { documentDraftsControllerList, documentDraftsControllerCreate, documentDraftsControllerHistory, documentDraftsControllerVersion, documentDraftsControllerMessage, documentDraftsControllerDownload }
}